import styled from "styled-components";

export const BaseScreen = styled.section`
  min-height: ${({ theme }) =>
    theme.isMobile ? "100vh" : `${theme.getValue(934)}px`};
`;

export default BaseScreen;
